import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { QUERY_KEYS } from '@restworld/utils-common';
import { useAuth } from '@restworld/feature-authentication';
import { IndexStripePaymentMethods, useOrganizationsService } from '@restworld/data-services';

function useEmployerStripePaymentMethodsQuery(enabled = true, companyId?: string) {
  const { user } = useAuth();
  const organisationsService = useOrganizationsService();
  const queryKey = useEmployerStripePaymentMethodsQueryKey();
  const organizationId = user?.organization_id;

  const query = useQuery({
    queryKey,
    queryFn: () => organisationsService.fetchStripePaymentMethods({ organizationId, companyId }),
    select: (data) => data.data,
    enabled: !!organizationId && enabled,
  });

  return { stripePaymentMethods: query.data, query };
}
export default useEmployerStripePaymentMethodsQuery;

export function useEmployerStripePaymentMethods() {
  const queryClient = useQueryClient();
  const queryKey = useEmployerStripePaymentMethodsQueryKey();
  const stripePaymentMethods: AxiosResponse<IndexStripePaymentMethods> = queryClient.getQueryData(queryKey);
  return stripePaymentMethods?.data;
}

export function useEmployerStripePaymentMethodsQueryKey() {
  const { user } = useAuth();
  const organizationId = user?.organization_id;

  return [QUERY_KEYS.ORGANISATIONS.STRIPE_PAYMENT_METHODS, organizationId];
}
